var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBodyTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.83333V7.5H19.6875V9.83333H13.125ZM13.125 5.16667V2.83333H23.625V5.16667H13.125ZM6.5625 21.5C4.74688 21.5 3.19922 20.9313 1.91953 19.7938C0.639844 18.6562 0 17.2806 0 15.6667C0 14.7333 0.229688 13.8632 0.689063 13.0563C1.14844 12.2493 1.79375 11.5639 2.625 11V4C2.625 3.02778 3.00781 2.20139 3.77344 1.52083C4.53906 0.840278 5.46875 0.5 6.5625 0.5C7.65625 0.5 8.58594 0.840278 9.35156 1.52083C10.1172 2.20139 10.5 3.02778 10.5 4V11C11.3313 11.5639 11.9766 12.2493 12.4359 13.0563C12.8953 13.8632 13.125 14.7333 13.125 15.6667C13.125 17.2806 12.4852 18.6562 11.2055 19.7938C9.92578 20.9313 8.37813 21.5 6.5625 21.5ZM3.15 13.1L4.725 12.4H6.3H9.45C9.45 11.8361 10.3633 14.5778 10.0898 14.0917C9.81641 13.6056 9.42813 13.1972 8.925 12.8667L7.875 12.1667V4C7.875 3.66944 7.74922 3.39236 7.49766 3.16875C7.24609 2.94514 6.93438 2.83333 6.5625 2.83333C6.19063 2.83333 5.87891 2.94514 5.62734 3.16875C5.37578 3.39236 5.25 3.66944 5.25 4V12.1667L4.2 12.8667C3.69688 13.1972 3.30859 13.6056 3.03516 14.0917C2.76172 14.5778 3.15 12.5361 3.15 13.1Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyTemperature);
export default __webpack_public_path__ + "static/media/body-temperature.ef82c21d8c3667d36ee4c656eed2b4e8.svg";
export { ForwardRef as ReactComponent };